import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { getCurrentThemeDraftId } from '../../store/clubs/selectors';
import BookingsPage from '../../components/bookings';
import { fetchWidgets } from '../../store/bookings/actions';
import {
  getWidgetDomain,
  getWidgetEnabled,
  getWidgetId,
  getWidgetScriptUrl,
  getWorkspaceName,
} from '../../store/bookings/selectors';
import Club404 from '../../components/errors/club-404';

class Bookings extends React.Component {
  static async getInitialProps({ club, reduxStore, res }) {
    const themeDraftId = getCurrentThemeDraftId(reduxStore.getState());

    const initialProps = {
      activeSection: 'bookings',
      namespacesRequired: ['common'],
      pageType: 'bookings.index',
      themeDraftId,
    };

    try {
      const { error } = await reduxStore.dispatch(fetchWidgets(club.id));
      if (error && error.errorStatusCode && res) {
        res.statusCode = error.errorStatusCode;
      }

      return initialProps;
    } catch (err) {
      return initialProps;
    }
  }

  componentDidMount() {
    const { scriptUrl } = this.props;

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    const { club, workspaceName, widgetId, widgetDomain, widgetEnabled } = this.props;
    const { facilityBookingsEnabled } = club;

    if (!facilityBookingsEnabled || !widgetEnabled) {
      return <Club404 club={club} />;
    }

    return (
      <>
        <BookingsPage
          club={club}
          workspaceName={workspaceName}
          widgetId={widgetId}
          widgetDomain={widgetDomain}
        />
      </>
    );
  }
}

Bookings.defaultProps = {
  scriptUrl: '',
  workspaceName: '',
  widgetId: '',
  widgetDomain: '',
  widgetEnabled: false,
};

Bookings.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  scriptUrl: PropTypes.string,
  workspaceName: PropTypes.string,
  widgetId: PropTypes.string,
  widgetDomain: PropTypes.string,
  widgetEnabled: PropTypes.bool,
};

export default connect((state) => ({
  scriptUrl: getWidgetScriptUrl(state),
  workspaceName: getWorkspaceName(state),
  widgetId: getWidgetId(state),
  widgetDomain: getWidgetDomain(state),
  widgetEnabled: getWidgetEnabled(state),
}))(Bookings);
